import {
  WrapperField as RaWrapperField,
  WrapperFieldProps as RaWrapperFieldProps,
} from 'react-admin';

export const WrapperField = RaWrapperField;

export type WrapperFieldProps = RaWrapperFieldProps;
